module.exports = __webpack_public_path__ + "static/media/26_BOJO_TRIANGULAR_ALCA_REGULAVEL_ESTAMPADO_01.808cf0e5.jpg";